// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import { getResources } from 'api/resource';

// ----------------------------------------------------------------------

const defaultParams = {
    query: '',
    pageNo: 1,
    perPage: 10,
    sortBy: 'title',
    sortDirection: 'DESC'
};

const initialState = {
    resources: [],
    params: defaultParams,
    resourcesCount: 0,
    isFetchingResources: true
};

const slice = createSlice({
    name: 'resource',
    initialState,
    reducers: {
        // SET Resources
        setResources(state, action) {
            const { data, isUpdateTotalCount } = action.payload;
            const { list = [], summary } = data;
            state.resources = list;

            // we will update the count
            if ((state.resourcesCount === 0 || isUpdateTotalCount) && summary) {
                const { total = 0 } = summary;
                state.resourcesCount = total;
            }
        },
        // SET Params
        setParams(state, action) {
            state.params = action.payload;
        },
        // SET Is Fetcing Resources
        setIsFetchingResources(state, action) {
            state.isFetchingResources = action.payload;
        }
    }
});

// eslint-disable-next-line prettier/prettier
export const {
    setResources,
    setParams,
    setIsFetchingResources,
} = slice.actions;

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchResources(params, isUpdateTotalCount = false) {
    return async () => {
        try {
            const result = await getResources(params);
            dispatch(
                slice.actions.setResources({
                    data: result?.data || [],
                    isUpdateTotalCount
                })
            );
        } catch (error) {
            console.log('error', error);
            dispatch(
                slice.actions.setResources({
                    data: []
                })
            );
        }
    };
}
